import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { PaywallDialogViewModel } from './PaywallDialogViewModel';
import { RevenueCatModel } from './revenue-cat/RevenueCatModel';
import { PaywallIcon } from '../components/icons/Icons';
import { MenuItem } from '../menu/MenuItem';

export const PaywallMenuButton: React.FC = () => {
    const paywall = useInstance(PaywallDialogViewModel);

    const revenueCat = useInstance(RevenueCatModel);
    useSubscription(() => revenueCat);

    let label = 'AutoPylot+';
    if (!revenueCat.hasUpgraded() && revenueCat.isEligibleForTrial()) {
        label = paywall.isPromotionActive() ? `Get AutoPylot+ ${paywall.getPromotionSaving()} off` : 'Try AutoPylot+ for $0';
    }

    const onClick = () => {
        paywall.open({ triggerSource: 'menu button' });
    };

    return (
        <div data-id="paywall-menu-button" data-type={revenueCat.hasUpgraded() ? 'downgrade' : 'upgrade'}>
            <MenuItem
                title={label}
                icon={PaywallIcon}
                color="primary"
                small
                bold
                onClick={onClick}
            />
        </div>
    );
};
